import localeIt from '@angular/common/locales/it';
import { SharedModule } from '@shared/shared.module';
import { IonicModule } from '@ionic/angular';
import { ModalErrorComponent } from './components/modal-error/modal-error.component';
import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { environment } from '@environments/environment';

registerLocaleData(localeIt);

@NgModule({
  declarations: [ModalErrorComponent],
  imports: [
    CommonModule,
    IonicModule,
    SharedModule,
    NgIdleKeepaliveModule.forRoot()
  ],
  providers: [{ provide: LOCALE_ID, useValue: environment.locale || 'it-IT' }]
})
export class CoreModule {}
